import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import {
  type GetTiersResponse,
  getTiersResponseSchema,
} from "@src/appV2/redesign/Tiers/api/schema";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";

interface GetTiersParams {
  workerIds: string[];
}

export function useGetTiers(
  params: GetTiersParams,
  options: UseQueryOptions<GetTiersResponse> = {}
): UseQueryResult<GetTiersResponse> {
  const { workerIds } = params;

  return useQuery<GetTiersResponse>({
    queryKey: ["tiers", workerIds],
    queryFn: async () => {
      const { data } = await get({
        url: `${environmentConfig.REACT_APP_ATTENDANCE_SCORE_SERVICE_URL}/tiers`,
        responseSchema: getTiersResponseSchema,
        queryParams: { filter: { "worker.id": workerIds.join(",") } },
      });

      return data;
    },
    ...options,
  });
}
